import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Container, Row, Card, CardHeader, CardBody, Input, Label, Table, Button, Spinner, ButtonGroup, ButtonToggle } from "@/Components/ui";
;
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import moment from "moment";
import { API_PACKAGE, getDataFromUrl, BACKEND_HOST, API } from "../../../api";
import { Calendar } from "react-calendar";
import Select from "react-select";
import { dialogService } from "@/utils/dialogService";
const ReservationOptionAddItem = () => {
    const { id } = useParams();
    const reserv_id = id;
    const navigate = useNavigate();
    const [spots, setSpots] = React.useState([]);
    const [spot, setSpot] = React.useState(null);
    const [phoneNum, setPhoneNum] = React.useState("");
    const [reservDate, setReservDate] = React.useState("");
    const [reservProduct, setReservProduct] = React.useState("");
    const [dateValue, setDateValue] = useState(new Date());
    const [reservLoading, setReservLoading] = useState(false);
    const [reservDatas, setReservDatas] = useState({});
    const [selectProducts, setSelectProducts] = useState([]);
    const [spotRadioValue, setSpotRadioValue] = useState("");
    const [searchLoading, setSearchLoading] = useState(false);
    const [userSearch, setUserSearch] = React.useState("");
    const [userList, setUserlist] = React.useState([]);
    // useEffect(() => {
    // }, [userSearch])
    const searchUser = useCallback(() => {
        setSearchLoading(false);
        // console.log("parseInt(userSearch)", parseInt(userSearch))
        if (!userSearch) {
            setUserlist([]);
        }
        else {
            setSearchLoading(true);
            API.get(`${BACKEND_HOST}/accounts/users-crm?search=${userSearch}`)
                .then(async (res) => {
                console.log("search load:", res.data);
                if (res.data?.results)
                    setUserlist(res.data.results);
                else
                    await dialogService.handleAlert("search error...");
                setSearchLoading(false);
            })
                .catch(async (e) => {
                await dialogService.handleAlert(e, { force: "error" });
                setSearchLoading(false);
            });
        }
    }, [userSearch]);
    useEffect(() => {
        if (spotRadioValue)
            setSpot(spots.find((item) => {
                return spotRadioValue == item.name;
            }));
        else
            setSpot(null);
    }, [spots, spotRadioValue]);
    const targetDate = useMemo(() => {
        if (reservDate)
            return moment(reservDate, "YYYY-MM-DD").toDate();
        else
            new Date();
    }, [reservDate]);
    useEffect(() => {
        setDateValue(targetDate);
        setSpotRadioValue("");
    }, [targetDate]);
    useEffect(() => {
        changeMonth(new Date());
    }, []);
    useEffect(() => {
        const _date = moment(dateValue).format("YYYY-MM-DD");
        if (!!reservDate || reservDate !== _date)
            setReservDate(_date);
    }, [dateValue]);
    useEffect(() => {
        setReservProduct(null);
    }, [reservDate]);
    const changeMonth = (_target) => {
        setReservLoading(true);
        setDateValue(_target);
        // var lastDayOfMonth = new Date(_target.getFullYear(), _target.getMonth() + 1, 0);
        (async () => {
            const datas = await getDataFromUrl(`${API_PACKAGE}/status-montly/?year=${_target.getFullYear()}&month=${_target.getMonth() + 1}`);
            console.log(datas);
            if (datas && datas.result) {
                const _datas = {};
                for (let i = 0; i < datas.result.length; i++) {
                    _datas[datas.result[i][0]["date"]] = datas.result[i];
                }
                setReservDatas(_datas);
            }
            setReservLoading(false);
        })().catch((e) => {
            console.log(e);
        });
    };
    React.useEffect(() => {
        console.log("id: ", reserv_id);
        if (reserv_id) {
            // reserv_id = 6057
            API.get(`${BACKEND_HOST}/package/reservations/${reserv_id}/`)
                .then((res) => {
                console.log("data load:", reserv_id, res.data);
                fillStates(res.data);
            })
                .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
        }
    }, [reserv_id]);
    useEffect(() => {
        API.get(`${BACKEND_HOST}/package/items/`)
            .then(({ data }) => {
            console.log("package products load:", data);
            setSelectProducts(data.filter((item) => {
                return item.min_date === 1 && item.max_date === 1;
            }).map((item) => {
                return { label: item["상품명"], value: item.id };
            }));
            // "id": 53,
            // "상품명": "테이블이용권",
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    }, []);
    useEffect(() => {
        if (reservDate && reservProduct)
            API.get(`${BACKEND_HOST}/package/items/?date=${reservDate}`)
                .then(({ data }) => {
                console.log("products spot load:", data);
                const _product = data.find((item) => {
                    return item.name === reservProduct;
                });
                if (_product && _product["spots"])
                    setSpots(_product["spots"]);
                if (spotRadioValue)
                    setSpot(spots.find((_spot) => {
                        return _spot.name === spotRadioValue;
                    }));
                // {
                //     "id": 376,
                //     "name": "1",
                // }
            })
                .catch((e) => console.log(e));
        else
            setSpots([]);
    }, [reservDate, reservProduct]);
    const fillStates = (data) => {
        //     "id": 6057,
        // "예약신청일": "2023-02-15T22:01:41.031394",
        // "예약상품": "테스트이용권",
        // "자리": "1",
        // "예약자": "이기환",
        // "번호": "01073032625",
        // "예약시작일": "2023-02-19",
        // "이용기간": 1,
        // "예약상태": "예약",
        // "결제상태": "예약완료",
        // "승인번호": null,
        // "결제금액": 3000,
        // "gifted": "",
        // "options": []
        setReservDate(data["예약시작일"]);
        setPhoneNum(data["번호"]);
        setReservProduct(data["예약상품"]);
        // setSpot(data["자리"]);
        setSpotRadioValue(data["자리"]);
    };
    const updateData = async () => {
        const data = await checkData();
        console.log(data);
    };
    const addReservData = async () => {
        const data = await checkData();
        console.log(data);
        if (data === null)
            return;
        API.post(`${BACKEND_HOST}/package/add-reservation-crm/`, {
            phone_num: data.phoneNum,
            spot_id: data.spot.id,
            resv_date: data.reservDate,
        })
            .then(async (res) => {
            if (res.data.result === "ok") {
                await dialogService.handleAlert("add reservation ok! ");
                history.go(0);
            }
            else {
                await dialogService.handleAlert("something went wrong!");
                console.log("add reservation failed.", res.data);
            }
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    };
    const checkData = async () => {
        if (!phoneNum || !reservDate || !reservProduct) {
            await dialogService.handleAlert("필수 입력값이 없습니다.");
            return null;
        }
        const data = {
            phoneNum: phoneNum,
            reservDate: reservDate,
            reservProduct: reservProduct,
            spot: spot,
        };
        return data;
    };
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="예약 옵션 구매 등록" pageTitle="예약 옵션"/>

          <Row className="g-4 mb-3">
            <div className="col-sm-auto">
              <div>
                <h4 className="card-title mb-0 flex-grow-1">등록 및 수정</h4>
              </div>
            </div>
            <div className="col-sm-3 ms-auto">
              <div className="d-flex justify-content-sm-end gap-2">
                {!reserv_id ? (<Button color="success" className="add-btn me-1" onClick={addReservData} id="create-btn">
                    Add
                  </Button>) : (<Button color="success" className="add-btn me-1" onClick={updateData} id="create-btn">
                    Update
                  </Button>)}
                <Button color="danger" className="add-btn me-1" onClick={() => {
            navigate(-1);
        }} id="cancel-btn">
                  Cancel
                </Button>
              </div>
            </div>
          </Row>

          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <div className="live-preview">
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="phonenumberInput" className="form-label">
                            고객 전화번호
                          </Label>
                          <Input type="text" className="form-control" placeholder="고객정보를 검색해서 선택해 주세요" id="phoneNum" value={phoneNum} onChange={(e) => {
            setPhoneNum(e.target.value);
        }} maxLength="11" disabled/>
                          <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                            <input onChange={(e) => {
            setUserSearch(e.target.value);
        }} id="search-bar-0" type="text" className="form-control search mt-1" style={{ width: "80%" }} placeholder={`Search User here...`} value={userSearch}/>
                            <Button onClick={() => {
            searchUser();
        }} color="soft-light" className="me-1 text-dark">
                              <i className="bx bx-search-alt search-icon"></i>
                            </Button>
                            <Button onClick={() => {
            setUserSearch("");
            setUserlist([]);
        }} color="soft-secondary" className="me-1">
                              <i className="bx bx-reset"></i>
                            </Button>
                          </div>
                        </div>
                      </Col>
                      <Col>
                        {searchLoading ? (<div style={{}}>
                            <Spinner color="primary"> Searching... </Spinner>
                          </div>) : null}
                        {!!userList &&
            userList.map((user, idx) => {
                if (idx > 4)
                    return null;
                return (<Button className="m-1" key={user.id} color="link" style={{ boxShadow: "none" }} onClick={() => {
                        setPhoneNum(user["전화번호"]);
                    }}>
                                <span>
                                  {user["이름"]} {user["전화번호"]}
                                </span>
                              </Button>);
            })}
                        <span>{!!userList && userList.length > 5 ? "..." : null}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="firstNameinput" className="form-label">
                            예약날짜
                          </Label>
                          <Input type="text" className="form-control" placeholder="예약날짜" id="reservation-date" value={reservDate} onChange={(e) => setReservDate(e.target.value)} maxLength="11" disabled/>
                        </div>
                      </Col>
                      <Col>
                        {reservLoading ? (<div style={{}}>
                            <Spinner color="primary"> Loading... </Spinner>
                            <span>데이터를 로딩하는 중입니다...</span>
                          </div>) : (<React.Fragment>
                            <Calendar onChange={setDateValue} value={dateValue} calendarType="US" onClickMonth={(value) => {
                changeMonth(value);
            }} onActiveStartDateChange={({ action, activeStartDate, value, view }) => {
                console.log("Calendar onActiveStartDateChange:", action);
                if (view === "month") {
                    changeMonth(activeStartDate);
                }
            }} tileContent={({ activeStartDate, date, view }) => {
                const datestring = moment(date).format("YYYY-MM-DD");
                if (reservDatas[datestring]) {
                    return (<>
                                      {reservDatas[datestring].map((val, idx) => {
                            if (val.price)
                                return (<span key={idx} style={{ color: "#000" }}>
                                              <br />
                                              {`${val.name} (${val.reserved}/${val.count})`}
                                            </span>);
                            else
                                return (<span key={idx} style={{ color: "#888" }}>
                                              <br />
                                              <strike>{`${val.name} (${val.reserved}/${val.count})`}</strike>
                                            </span>);
                        })}
                                    </>);
                }
            }}/>
                          </React.Fragment>)}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div>
                          <Label htmlFor="formFile" className="form-label">
                            예약상품
                          </Label>
                          {/* <Input type="text" className="form-control" placeholder="" id="reservation-product" value={reservProduct} onChange={(e) => (setReservProduct(e.target.value))} maxLength="100" disabled /> */}
                          <Select className="mb-0" 
    // defaultValue={selectProducts.find((val) => {
    //     return reservProduct === val.label
    // })}
    value={(() => {
            const _value = selectProducts.find((val) => {
                return reservProduct === val.label;
            });
            if (!_value)
                return null;
            else
                return _value;
        })()} onChange={(val) => {
            setReservProduct(val.label);
            // if (cellProps.row.original['예약상태'].valueOf() === val.value.valueOf()) return
            // changeReservationState(cellProps.row.original.id, val.value).then((data) => {
            //     console.log("changeReservationState", data)
            //     toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original['예약자']} ${cellProps.row.original['예약상태']}=>${val.value}`, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //         progress: undefined,
            //         theme: "light",
            //     });
            // });
        }} options={selectProducts} id={"choices-single-reservation-product"}></Select>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <div>
                          <Label htmlFor="formFile" className="form-label">
                            자리번호
                          </Label>
                          <Input type="text" className="form-control" placeholder="" id="spot" value={spotRadioValue} maxLength="4" disabled/>
                        </div>
                      </Col>
                      <Col>
                        <div style={{ marginTop: "27px", display: "flex", flexWrap: "wrap", alignContent: "start", alignItems: "start", justifyItems: "start", justifyContent: "start", gap: "4px" }}>
                          {/* <ButtonGroup style={{marginTop: "27px"}}> */}
                          {spots.map((spot, idx) => {
            return (<Button key={idx} id={`spot-radio-${idx}`} color={spot.is_able ? "primary" : "danger"} outline value={spot.name} onClick={(e) => setSpotRadioValue(e.currentTarget.value)} active={spotRadioValue === spot.name} disabled={!spot.is_able}>
                                <span>{spot.is_able ? spot.name : " X"}</span>
                              </Button>);
        })}
                          {/* </ButtonGroup> */}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>);
};
export default ReservationOptionAddItem;
